import { getNotificationsTypesAPI } from 'api/endpoints/notifications/notifications.api';
import * as NotificationsTypes from './notifications.types';
import { ITranslate } from 'interfaces/general.interface';
// import { myBrandsError } from 'utils/errorCodes';
// import { notificationError } from 'views/components/UI/notification';
// import { messageError, messageSuccess, messageWarning } from 'views/components/UI/message';

export async function getNotificationsAction(
  dispatch: React.Dispatch<any>,
  translate: ITranslate
) {
  return dispatch({
    type: NotificationsTypes.SET_NOTIFICATIONS,
  });
}

export async function markAsReadedAction(
  dispatch: React.Dispatch<any>,
  type: string,
  notificationId: string,
  read: boolean,
  translate: ITranslate
) {
  if (type === 'notification') {
    return dispatch({
      type: NotificationsTypes.MARK_AS_READED_NOTIFICATION,
      payload: {
        id: notificationId,
        readed: read,
      },
    });
  }
}

export async function getNotificationsTypesAction({
  dispatch,
  translate,
  token,
}: {
  dispatch: React.Dispatch<any>;
  translate: ITranslate;
  token: string;
}): Promise<boolean> {
  try {
    const getNotificationsTypes = await getNotificationsTypesAPI({ token });
    if (getNotificationsTypes.response.status === 200) {
      dispatch({
        type: NotificationsTypes.SET_NOTIFICATIONS_TYPES,
        payload: getNotificationsTypes.data.filter((item) => item.brand_only === false),
      });
      return true;
    }
    return false;
  } catch (error) {
    console.log(error);
    return false;
  }
}
